import {
  useCartLineItems,
  useCartShippingAddress,
  useCartState,
  useCartTaxPrice,
  useCartTotalAmount
} from '@ecomm/data-cart'
import {
  AFFIRM_FINANCING_PROGRAM,
  AFFIRM_FINANCING_PROGRAM_VARIANT,
  AFFIRM_NO_SYSTEM_FINANCING_PROGRAM
} from '@ecomm/data-constants'
import { useLocale } from '@ecomm/data-hooks'
import type { AffirmCheckoutData } from '@simplisafe/ss-ecomm-data/affirm'

export function useAffirmCheckoutData(
  isAffirmExperience = false
): AffirmCheckoutData | undefined {
  const locale = useLocale()
  const state = useCartState()
  const lineItems = useCartLineItems()
  const shippingAddress = useCartShippingAddress()
  const totalPrice = useCartTotalAmount()
  const taxPrice = useCartTaxPrice()
  const total = totalPrice + taxPrice

  // @ts-expect-error TS2322
  const affirmLineItems: AffirmCheckoutData['items'] = lineItems
    .filter(l => !l.isServicePlan)
    .map(item => ({
      display_name: item.name[locale],
      sku: item.id ?? '',
      qty: item.quantity,
      // @ts-expect-error TS2532
      unit_price: item.pricesAfterDiscount[locale].centAmount
    }))

  const domain =
    locale === 'en-US' ? 'https://simplisafe.com' : 'https://simplisafe.co.uk'
  const hasSystem = lineItems.some(l => l.packageItems.length > 0)

  const financingProgram =
    locale === 'en-US'
      ? hasSystem
        ? isAffirmExperience
          ? AFFIRM_FINANCING_PROGRAM_VARIANT
          : AFFIRM_FINANCING_PROGRAM
        : AFFIRM_NO_SYSTEM_FINANCING_PROGRAM
      : ''

  return state === 'with_items' && shippingAddress
    ? {
        financing_program: financingProgram,
        items: affirmLineItems,
        merchant: {
          merchant: 'SimpliSafe, Inc.',
          user_cancel_url: domain,
          user_confirmation_url: domain,
          user_confirmation_url_action: 'GET'
        },
        metadata: { mode: 'modal' },
        shipping: {
          address: {
            city: shippingAddress.city,
            country: shippingAddress.country,
            line1: shippingAddress.streetName,
            line2: shippingAddress.additionalStreetInfo,
            state: shippingAddress.state,
            zipcode: shippingAddress.postalCode
          },
          email: shippingAddress.email,
          name: {
            first: shippingAddress.firstName,
            last: shippingAddress.lastName
          },
          phone_number: shippingAddress.phone
        },
        total
      }
    : undefined
}
